import { CREATE_DMX_DEVICE, CREATE_DMX_DEVICE_SUCCESSFUL, CREATE_DMX_DEVICE_FAILED } from './actionTypes';

const initialState = {
  createDmxDeviceError: null,
  messageDmxDevice: null,
  loadingCreateDmxDevice: false,
};

const createDevice = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DMX_DEVICE:
      state = { ...state, loadingCreateDmxDevice: true, createDmxDeviceError: null };
      break;
    case CREATE_DMX_DEVICE_SUCCESSFUL:
      state = { ...state, loadingCreateDmxDevice: false, messageDmxDevice: action.payload, createDmxDeviceError: null };
      break;
    case CREATE_DMX_DEVICE_FAILED:
      state = { ...state, messageDmxDevice: null, loadingCreateDmxDevice: false, createDmxDeviceError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createDevice;
